import { get, isNil } from "lodash";
import { zoneChip } from "./guide-choices";
import { GUIDE_KINDS, GUIDE_STEPS } from "./screen-groups";
import { slotKindOf } from "./workshop-view";

const ITEM_SUFFIX = "_item";

export const ZONE_KINDS = { ONE: "one", LIST: "list", CARD: "card" };

export const ZONES_MESSAGE = "kayros-zones";

export const ZONES_READY_MESSAGE = "kayros-zones-ready";

const CARD_MAX_SLOTS = 12;

const CARD_MIN_HEIGHT = 48;

const STYLE = [
  "[data-kayros-slot],[data-kz-card]{cursor:pointer;}",
  ".kz-show [data-kz='one']{outline:1.5px dashed #9ccbeb;outline-offset:4px;}",
  ".kz-show [data-kz='guided']{outline:1.5px dashed #e0b45a;outline-offset:6px;}",
  ".kz-hover,.kz-on{outline:2px solid #0a72b5 !important;outline-offset:4px !important;}",
  "[data-kz='guided'].kz-hover,[data-kz='guided'].kz-on{outline-color:#c98a12 !important;outline-offset:6px !important;}",
  ".kz-zone{outline:1.5px dashed #e0b45a !important;outline-offset:2px !important;}",
  ".kz-zone.kz-zone-set{outline:1.5px solid #2f9e5b !important;}",
  ".kz-zone.kz-zone-on{outline:2.5px solid #c98a12 !important;background-color:rgba(255,246,224,0.9) !important;}",
  ".kz-cited{box-shadow:0 0 0 4px rgba(10,114,181,0.3) !important;border-radius:4px;}",
  ".kz-tag{position:fixed;z-index:2147483647;pointer-events:none;display:none;align-items:center;height:22px;padding:0 8px;border-radius:6px;",
  "font:700 12px/22px Figtree,'Segoe UI',sans-serif;color:#ffffff;background:#0a72b5;white-space:nowrap;}",
  ".kz-tag.kz-tag--guided{background:#a86f0a;}",
  ".kz-tag.kz-tag--chip{z-index:2147483646;height:18px;padding:0 6px;font-size:11px;line-height:18px;background:#1f7a45;}",
  ".kz-tag.kz-tag--model{z-index:2147483646;background:#fff6e0;color:#6b520b;}",
].join("");

const SCRIPT = [
  "(function(){",
  "var C=null,hoverEl=null,SLOT='data-kayros-slot',tags={hover:null,on:null},extra=[];",
  "function sid(el){return el&&el.getAttribute?el.getAttribute(SLOT):null;}",
  "function typeOf(id){return (C&&id&&C.types[id])||'';}",
  "function q(id){return /^[A-Za-z0-9_-]+$/.test(id||'')?document.querySelector('['+SLOT+'=\"'+id+'\"]'):null;}",
  "function each(list,fn){Array.prototype.forEach.call(list,fn);}",
  "function idsIn(el){return Array.prototype.map.call(el.querySelectorAll('['+SLOT+']'),sid);}",
  "function listOf(el){var n=el;while(n&&n.getAttribute){if(typeOf(sid(n))==='list')return n;n=n.parentElement;}return null;}",
  "function clear(c){return !c||c==='transparent'||/rgba\\([^)]*,\\s*0\\)$/.test(c);}",
  "function bgOf(el){var n=el;while(n&&n.nodeType===1){var c=getComputedStyle(n).backgroundColor;if(!clear(c))return c;n=n.parentElement;}return 'rgb(255, 255, 255)';}",
  "function boxed(el){var s=getComputedStyle(el);",
  "var sides=['Top','Right','Bottom','Left'];for(var i=0;i<4;i++){var k=sides[i];",
  "if(parseFloat(s['border'+k+'Width'])>0&&s['border'+k+'Style']!=='none'&&!clear(s['border'+k+'Color']))return true;}",
  "if(s.boxShadow&&s.boxShadow!=='none')return true;",
  "return !clear(s.backgroundColor)&&!!el.parentElement&&s.backgroundColor!==bgOf(el.parentElement);}",
  "function cardOk(el){",
  "if(el===document.body||el===document.documentElement||el.hasAttribute(SLOT)||listOf(el))return false;",
  "var ids=idsIn(el);if(ids.length<2||ids.length>" +
    CARD_MAX_SLOTS +
    ")return false;",
  "var texts=0;for(var i=0;i<ids.length;i++){var t=typeOf(ids[i]);",
  "if(t==='input'||t==='list'||(!t&&/_item$/.test(ids[i])))return false;if(t==='text')texts++;}",
  "return texts>=2&&el.getBoundingClientRect().height>=" +
    CARD_MIN_HEIGHT +
    "&&boxed(el);}",
  "function known(id){var t=typeOf(id);return t==='text'||t==='image'||t==='input'||t==='action'||t==='list';}",
  "function slotOf(t){var n=t.closest?t.closest('['+SLOT+']'):null;",
  "while(n&&!known(sid(n))&&!/_item$/.test(sid(n)||'')){n=n.parentElement?n.parentElement.closest('['+SLOT+']'):null;}return n;}",
  "function mark(){",
  "each(document.querySelectorAll('[data-kz]'),function(el){el.removeAttribute('data-kz');});",
  "each(document.querySelectorAll('[data-kz-card]'),function(el){el.removeAttribute('data-kz-card');});",
  "var all=document.querySelectorAll('['+SLOT+']');",
  "each(all,function(el){if(typeOf(sid(el))!=='text')return;var n=el.parentElement;",
  "while(n&&n!==document.body){if(n.hasAttribute('data-kz-card'))return;",
  "if(cardOk(n)){n.setAttribute('data-kz-card','');n.setAttribute('data-kz','guided');return;}n=n.parentElement;}});",
  "each(all,function(el){var id=sid(el),t=typeOf(id);if(!known(id))return;",
  "if(t==='list'){el.setAttribute('data-kz','guided');return;}",
  "if(listOf(el.parentElement))return;",
  "el.setAttribute('data-kz','one');});}",
  "function zoneOf(t){if(!t||!t.closest)return null;var n=slotOf(t);var card=t.closest('[data-kz-card]');",
  "if(card&&(!n||!card.contains(n)))return {el:card,kind:'card',slot:null};",
  "if(!n)return null;",
  "if(/_item$/.test(sid(n)||'')){var owner=q(sid(n).replace(/_item$/,''));return owner?{el:owner,kind:'list',slot:null}:null;}",
  "var list=listOf(n);if(list)return {el:list,kind:'list',slot:list===n?null:n};",
  "return {el:n,kind:'one',slot:n};}",
  "function label(kind,el){if(kind==='list')return C.labels.list;if(kind==='card')return C.labels.card;",
  "var id=sid(el),t=(C.kinds&&C.kinds[id])||typeOf(id);return (C.labels.types[t]||C.labels.types[typeOf(id)]||t)+' \\u00b7 '+C.labels.one;}",
  "function tag(cls){var t=document.createElement('div');t.className='kz-tag'+(cls?' '+cls:'');document.body.appendChild(t);return t;}",
  "function ensure(){if(!tags.hover&&document.body){tags.hover=tag();tags.on=tag();}return !!tags.hover;}",
  "function place(t,el,text,top){if(!t||!el){if(t)t.style.display='none';return;}t.textContent=text;t.style.display='inline-flex';",
  "var r=el.getBoundingClientRect(),w=t.offsetWidth;",
  "if(top){t.style.left=Math.max(2,r.left)+'px';t.style.top=Math.max(2,r.top-20)+'px';return;}",
  "t.style.left=Math.max(2,Math.min(r.right-w-4,window.innerWidth-w-2))+'px';t.style.top=Math.max(2,r.top-26)+'px';}",
  "function hover(z){if(!ensure())return;if(hoverEl&&(!z||z.el!==hoverEl))hoverEl.classList.remove('kz-hover');",
  "hoverEl=z?z.el:null;if(!z){place(tags.hover,null);return;}",
  "z.el.classList.add('kz-hover');tags.hover.className='kz-tag'+(z.kind==='one'?'':' kz-tag--guided');place(tags.hover,z.el,label(z.kind,z.el));}",
  "function selected(){var s=C.selected;if(!s)return null;",
  "if(s.kind==='card'){var f=s.ids&&s.ids.length?q(s.ids[0]):null;var card=f?f.closest('[data-kz-card]'):null;return card?{el:card,kind:'card'}:null;}",
  "var el=q(s.id);return el?{el:el,kind:s.kind}:null;}",
  "function layout(){if(!ensure())return;var s=C?selected():null;",
  "if(s){tags.on.className='kz-tag'+(s.kind==='one'?'':' kz-tag--guided');place(tags.on,s.el,label(s.kind,s.el));}else place(tags.on,null);",
  "each(extra,function(x){place(x.tag,x.el,x.text,true);});",
  "if(hoverEl)place(tags.hover,hoverEl,tags.hover.textContent);}",
  "function apply(){if(!C||!ensure())return;",
  "document.documentElement.classList.toggle('kz-show',!!C.show);mark();",
  "each(document.querySelectorAll('.kz-on,.kz-zone,.kz-cited'),function(el){el.classList.remove('kz-on','kz-zone','kz-zone-set','kz-zone-on','kz-cited');});",
  "each(C.cited||[],function(id){if(!/^[A-Za-z0-9_-]+$/.test(id||''))return;each(document.querySelectorAll('['+SLOT+'=\"'+id+'\"]'),function(el){el.classList.add('kz-cited');});});",
  "each(extra,function(x){x.tag.remove();});extra=[];",
  "var s=selected();if(s)s.el.classList.add('kz-on');",
  "var g=C.guide;if(g){",
  "if(g.model){var m=q(g.model.id);if(m)extra.push({tag:tag('kz-tag--model'),el:m,text:g.model.text});}",
  "each(g.zones||[],function(id){var z=q(id);if(!z)return;z.classList.add('kz-zone');",
  "if(g.chips&&g.chips[id]){z.classList.add('kz-zone-set');extra.push({tag:tag('kz-tag--chip'),el:z,text:g.chips[id]});}",
  "if(id===g.current)z.classList.add('kz-zone-on');});}",
  "layout();}",
  "function post(m){parent.postMessage(m,'*');}",
  "window.addEventListener('load',function(){if(C)apply();});",
  "document.addEventListener('DOMContentLoaded',function(){ensure();post({type:'" +
    ZONES_READY_MESSAGE +
    "'});});",
  "window.addEventListener('message',function(e){if(e.source!==parent||!e.data||e.data.type!=='" +
    ZONES_MESSAGE +
    "')return;C=e.data.config;if(document.body)apply();});",
  "document.addEventListener('mouseover',function(e){if(C)hover(zoneOf(e.target));});",
  "document.addEventListener('mouseleave',function(){if(C)hover(null);});",
  "window.addEventListener('scroll',function(){if(C)layout();},true);",
  "window.addEventListener('resize',function(){if(C)layout();});",
  "document.addEventListener('click',function(e){var t=e.target;if(!t||!t.closest)return;",
  "if(e.ctrlKey||e.metaKey){var c=slotOf(t);if(!c)return;e.preventDefault();e.stopPropagation();",
  "post({type:'kayros-slot-pick',additive:true,id:sid(c)});return;}",
  "var z=C?zoneOf(t):null;if(!z)return;e.preventDefault();e.stopPropagation();",
  "post({type:'kayros-slot-pick',additive:false,kind:z.kind,id:z.slot?sid(z.slot):null,",
  "list:z.kind==='list'?sid(z.el):null,ids:z.kind==='card'?idsIn(z.el):null});},true);",
  "})();",
].join("");

export const zoneAssets = () =>
  `<style>${STYLE}</style><script>${SCRIPT}</script>`;

const guideZones = ({ guide, labels }) => {
  if (isNil(guide) || guide.missing) return null;
  const chips = {};
  for (const slot of guide.zones) {
    const chip = zoneChip(slot, labels.guide, labels.fields);
    if (!isNil(chip)) chips[slot.id] = chip;
  }
  const current =
    guide.step === GUIDE_STEPS.ZONES
      ? get(guide.zones, [guide.zone, "id"])
      : null;
  return {
    zones: guide.zones.map((slot) => slot.id),
    current: current || null,
    chips,
    model:
      guide.kind === GUIDE_KINDS.LIST && guide.listSlot
        ? {
            id: `${guide.listSlot.id}${ITEM_SUFFIX}`,
            text: labels.guide.MODEL,
          }
        : null,
  };
};

const selectedZone = ({ guide, openSlotId }) => {
  if (!isNil(guide) && !guide.missing) {
    if (guide.kind === GUIDE_KINDS.LIST)
      return { kind: ZONE_KINDS.LIST, id: get(guide, "listSlot.id") || null };
    return {
      kind: ZONE_KINDS.CARD,
      ids: guide.zones.map((slot) => slot.id),
    };
  }
  return isNil(openSlotId) ? null : { kind: ZONE_KINDS.ONE, id: openSlotId };
};

export const previewZones = ({
  slots,
  show,
  labels,
  guide,
  openSlotId,
  cited,
}) => {
  const types = {};
  const kinds = {};
  for (const slot of slots || []) {
    types[slot.id] = slot.type;
    kinds[slot.id] = slotKindOf(slot);
  }
  return {
    types,
    kinds,
    show: Boolean(show),
    labels: {
      types: get(labels, "quick.TYPES") || {},
      one: get(labels, "quick.ONE") || "",
      list: get(labels, "guide.LIST_KIND") || "",
      card: get(labels, "guide.CARD_KIND") || "",
    },
    selected: selectedZone({ guide, openSlotId }),
    cited: cited || [],
    guide: guideZones({ guide, labels }),
  };
};
